const topMain = () => {
  const pageTop = (document.getElementById("pageTop") != null);
  if (pageTop) {



    let sW = window.innerWidth;

    const secMain = document.getElementById('jsSecMain');
    const mainWrap = secMain.querySelector('.js-main-wrap');


    setTimeout(() => {
      mainWrap.classList.add('act')
    }, 1000);



  }
};
export default topMain;